<template>
  <div>
    <a-modal
      width="70%"
      v-model="show"
      centered
      :title="$t('pdf')"
      :maskClosable="false"
      :okText="$t('print')"
      :cancelText="$t('cancel')"
      :cancelButtonProps="{ class: 'btn ts-whitespace-no-wrap btn-default' }"
      :footer="null"
      style="top: 3vh;"
      :zIndex="2000"
      @cancel="onCanel"
    >
      <div id="container">
        <iframe :src="src_pdf"></iframe>
      </div>
    </a-modal>
  </div>
</template>

<script>
export default {
  name: 'recieptPreview',
  props: ['show', 'src_pdf'],
  methods: {
    onCanel () {
      this.$emit('cancel', false)
    }
  }
}
</script>

<style scoped>
#container {
  width: 100%;
  height: 70vh;
  background: #acacac;
  text-align: center;
}
#container iframe {
  width: 100%;
  height: 70vh;
  border: 2px solid #8a8989;
}
#container i {
  margin-top: 32vh;
}
</style>
